/* eslint-disable @typescript-eslint/unbound-method */
/* eslint-disable @typescript-eslint/no-misused-promises */
import { FormHelper } from "./form/FormHelper";
import { FormWithValidation } from "./form/FormWithValidation";

export class ProfileEmailChange extends FormWithValidation {
	private readonly newEmailInput: JQuery;

	constructor(element: JQuery) {
		super(element);

		this.newEmailInput = element.find("#email");
		this.newEmailInput.on("input", FormHelper.proposeEmailSuggestion);
	}

	protected collectFormData(): Record<string, unknown> {
		return {
			newEmail: this.newEmailInput.val(),
		};
	}

	protected clearInputs(): void {
		this.newEmailInput.val("");
	}

	protected setCustomRules(): void {
		this.formRules.email = {
			required: true,
		};
	}
}
